import './modules/jquery.cycle2.min.js';
import './modules/owl.carousel.min.js';

jQuery(function($){	

	/* Slideshow
	------------------------------------------------ */
	$('.slideshow-slider').on('cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
		$(incomingSlideEl).find('.slide-text .slide-text-bg').css('left', '180%');
		$(incomingSlideEl).find('.slide-text .slide-text-bg').animate({'left': '100%'}, 700).delay(optionHash.cycleTimeout - 1000).animate({'left': '180%'}, 700);	
		$(incomingSlideEl).find('.slide-text-inner').css('top', '-100%').css('opacity', '0');
		$(incomingSlideEl).find('.slide-text-inner').delay(100).animate({'top': '0', 'opacity': '1'}, 600);
		$(incomingSlideEl).find('.slide-text-inner').delay(optionHash.cycleTimeout - 1200).animate({'top': '-100%', 'opacity': '0'}, 600);
	});	

	/* Tabbed Content
	------------------------------------------------ */
	$('.tab-button').click(function(){
		if(!$(this).hasClass('active-tab-btn')) {
			var targetEl = $(this).attr('href').substr(1);
			$('.tab-button').removeClass('active-tab-btn');
			$('.mobile-tab-button').removeClass('active-tab-btn');
			$(this).addClass('active-tab-btn');
			$('.mobile-tab-button[href="#'+targetEl+'"]').addClass('active-tab-btn');
			
			$('.tab-content').hide();
			$('#tab-'+targetEl).fadeIn(200);
		}
		return false;
	});
	$('.mobile-tab-button').click(function(){
		var targetEl = $(this).attr('href').substr(1);
		
		if(!$(this).hasClass('active-tab-btn')) {			
			$('.tab-button').removeClass('active-tab-btn');
			$('.mobile-tab-button').removeClass('active-tab-btn');
			$(this).addClass('active-tab-btn');
			$('.tab-button[href="#'+targetEl+'"]').addClass('active-tab-btn');
			
			$('.tab-content').hide();
			$('#tab-'+targetEl).slideDown(200);
			var offtop = $(this).offset().top - 64;
			 $('html, body').animate({
				scrollTop: offtop
			}, 250);
		} else {
			$(this).removeClass('active-tab-btn');
			$('#tab-'+targetEl).slideUp(300);
		}
		
		return false;
	});

	// $('.gallery-slideshow').owlCarousel({
		// loop:true,
		// margin:0,
		// nav:true,
		// items: 1		
	// })

	// $('.owl-thumbs').owlCarousel({
		// loop:true,
		// margin:10,
		// nav:true,
		// items: 5
		
	// })

	var sync1 = $("#sync1");
	var sync2 = $("#sync2");
	var $owl_slider;
	
	
	var thumbnailItemClass = '.owl-item';

var slides = sync1.owlCarousel({
  items:1,
  loop:false,
  margin:10,
  autoplay:false,
  nav: true,
  dots: false,
  navText: ['<span class="fa fa-chevron-left"></span>','<span class="fa fa-chevron-right"></span>'],
}).on('changed.owl.carousel', syncPosition);

	function syncPosition(el) {
	  $owl_slider = $(this).data('owl.carousel');
	  var loop = $owl_slider.options.loop;

	  if(loop){
		var count = el.item.count;
		var current = Math.round(el.item.index - (el.item.count/2) - .5);
		if(current < 0) {
			current = count;
		}
		if(current > count) {
			current = 0;
		}
	  }else{
		var current = el.item.index;
	  }
	  

	  var owl_thumbnail = sync2.data('owl.carousel');
	  var itemClass = "." + owl_thumbnail.options.itemClass;


	  var thumbnailCurrentItem = sync2
	  .find(itemClass)
	  .removeClass("synced")
	  .eq(current);

	  thumbnailCurrentItem.addClass('synced');

	  if (!thumbnailCurrentItem.hasClass('active')) {
		var duration = 300;
		sync2.trigger('to.owl.carousel',[current, duration, true]);
	  }   
	}

	var thumbs = sync2.owlCarousel({
	  startPosition: 12,
	  items:4,
	  loop:false,
	  margin:5,
	  autoplay:false,
	  nav: false,
	  dots: false,
	  onInitialized: function (e) {
		var thumbnailCurrentItem =  $(e.target).find(thumbnailItemClass).eq(this._current);
		thumbnailCurrentItem.addClass('synced');
	  },
	})
	.on('click', thumbnailItemClass, function(e) {
		e.preventDefault();
		var duration = 300;
		var itemIndex =  $(e.target).parents(thumbnailItemClass).index();
		sync1.trigger('to.owl.carousel',[itemIndex, duration, true]);
	}).on("changed.owl.carousel", function (el) {
	  var number = el.item.index;
	  $owl_slider = sync1.data('owl.carousel');
	  $owl_slider.to(number, 100, true);
	});

	// var slidesPerPage = 3; //globaly define number of elements per page
	// var syncedSecondary = true;

	// sync1.owlCarousel({
		// items : 1,
		// slideSpeed : 3000,
		// nav: false,
		// autoplay: false,
		// dots: false,
		// loop: false,
		// navContainer: '#ig-owl-nav',
		// responsiveRefreshRate : 200,
		// navText: ['<span class="fa fa-chevron-left"></span>','<span class="fa fa-chevron-right"></span>']
	// }).on('changed.owl.carousel', syncPosition);

	// sync2.on('initialized.owl.carousel', function () {
		// sync2.find(".owl-item").eq(0).addClass("current");
	// }).owlCarousel({
		// items : slidesPerPage,
		// dots: false,
		// nav: true,
		// loop: false,
		// margin:12,
		// smartSpeed: 200,
		// slideSpeed : 500,		
		// slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
		// responsiveRefreshRate : 100
	// }).on('changed.owl.carousel', syncPosition2);

	// function syncPosition(el) {
	// //if you set loop to false, you have to restore this next line
	// //var current = el.item.index;

	// //if you disable loop you have to comment this block
	// // var count = el.item.count-1;
	// // var current = Math.round(el.item.index - (el.item.count/2) - .5);

	// // if(current < 0) {
	  // // current = count;
	// // }
	// // if(current > count) {
	  // // current = 0;
	// // }

	// //end block

	// sync2
	  // .find(".owl-item")
	  // .removeClass("current")
	  // .eq(current)
	  // .addClass("current");
	// var onscreen = sync2.find('.owl-item.active').length - 1;
	// var start = sync2.find('.owl-item.active').first().index();
	// var end = sync2.find('.owl-item.active').last().index();

	// if (current > end) {
	  // sync2.data('owl.carousel').to(current, 100, true);
	// }
	// if (current < start) {
	  // sync2.data('owl.carousel').to(current - onscreen, 100, true);
	// }
	// }

	// function syncPosition2(el) {
	// if(syncedSecondary) {
	  // var number = el.item.index;
	  // sync1.data('owl.carousel').to(number, 100, true);
	// }
	// }

	// sync2.on("click", ".owl-item", function(e){
	// e.preventDefault();
	// var number = $(this).index();
	// sync1.data('owl.carousel').to(number, 300, true);
	// });

	
	$('#nav ul li.menu-item-has-children, #header-top ul li.menu-item-has-children').each(function(){
		$(this).append('<span class="mobnav-subarrow"></span>');		
	});

	$('.mobnav-subarrow').on('click',
		function() {
			$(this).toggleClass('subarrow-expanded');
			$(this).siblings('ul').slideToggle(200);
			
			$(this).closest('li').toggleClass('li-expanded');
			return false;
	});
	
	$('#menu-toggle').on('click', function(){
		$(this).toggleClass('active-mt');
		$('body').toggleClass('mmenu-active');
		$('#header-content').slideToggle(250);
		return false;
	});
	
});